import CustomRequestForm from '../../components/CustomRequestForm/CustomRequestForm';

const OnePageRequest = () => (
  <>
    <title>One-Pager anfragen – Nexite IT</title>
    <meta name="robots" content="noindex" />
    <CustomRequestForm
    planTitle="One Pager Komplett"
    features={[
      'Individuelles Design',
      'Responsive Umsetzung',
      'Domain & Hosting (1 Jahr)',
      'SEO-Basisoptimierung',
      'Datenschutzerklärung',
      'Kontaktformular',
      '1 Monat Wartung',
      '2 Jahre Gültigkeit'
    ]}
    originalPrice={2500}
    discountPrice={1300}
    serviceId="service_02f1b5n"
    templateId="template_a1924op"
    publicKey="Et4UfxopuEn0IbQm8"
    returnLink="/pricing"
    successMessage="Wir haben Ihre Anfrage erhalten und melden uns innerhalb von 24 Stunden bei Ihnen."
    formFields={[
      {
        name: 'name',
        label: 'Ihr Name',
        type: 'text',
        required: true,
        placeholder: 'Max Mustermann'
      },
      {
        name: 'email',
        label: 'E-Mail-Adresse',
        type: 'email',
        required: true,
        placeholder: 'max@mustermann.de'
      },
      {
        name: 'phone',
        label: 'Telefonnummer',
        type: 'tel',
        placeholder: '+49 170 1234567'
      }
    ]}
    />
  </>
);

export default OnePageRequest;